import React, { useEffect } from 'react';

const AdBanner = ({ clientId, slotId, position, visualizationMode }) => {
  useEffect(() => {
    if (!visualizationMode) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error('AdSense error:', e);
      }
    }
  }, [visualizationMode]);

  if (visualizationMode) {
    return (
      <div className={`ad-placeholder ad-placeholder-${position}`}>
        <p>Ad Unit: {position}</p>
      </div>
    );
  }

  if (!clientId || !slotId) {
    return null;
  }

  return (
    <div className="ad-banner-container">
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={clientId}
        data-ad-slot={slotId}
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
    </div>
  );
};

export default AdBanner;